import React, { useState, useEffect, useRef } from 'react';
import { FaMagic, FaMicrophone } from 'react-icons/fa';
import { PulseLoader } from 'react-spinners'; 
import '../css/Chatbot.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Icon from '../assests/Spark_logo.png'
import { Loader, Placeholder } from 'rsuite';

const Chatbot = ({ playerRef, id }) => {
  const [message, setMessage] = useState('');
  const [conversation, setConversation] = useState([
    { text: 'Hello! How may I help you today?', isUser: false },
  ]);
  const [selectedLanguage, setSelectedLanguage] = useState('en-US');
  const [placeholder, setPlaceholder] = useState('Type your message');
  const [loading, setLoading] = useState(false); // Add loading state
  // const [isRecording, setIsRecording] = useState(false); // Recording state
  // const mediaRecorderRef = useRef(null);
  // const audioChunksRef = useRef([]);
  // const silenceTimer = useRef(null);
  const chatbotBodyRef = useRef(null);

  useEffect(() => {
    scrollToBottom();
  }, [conversation]);

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const scrollToBottom = () => {
    if (chatbotBodyRef.current) {
      chatbotBodyRef.current.scrollTop = chatbotBodyRef.current.scrollHeight;
    }
  };

  const handleInputChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  const handleSendMessage = async () => {
    if (message.trim() !== '') {
      setConversation(prev => [...prev, { text: message, isUser: true }]);
      setMessage('');
      setLoading(true); // Show loader
      try {
        const response = await fetch(`https://km0yl5vd0a.execute-api.ap-south-1.amazonaws.com/dev/videobot/?id=${id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ prompt: message, language: selectedLanguage }),
        });
        if (response.ok) {
          const data = await response.json();
          console.log('API response data:', data);
          setConversation(prev => [...prev, { text: data.body, isUser: false }]);
        } else {
          console.error('Response not OK:', response.statusText);
          setConversation(prev => [...prev, { text: 'An error occurred. Please try again.', isUser: false }]);
        }
      } catch (error) {
        console.error('Error:', error);
        setConversation(prev => [...prev, { text: 'An error occurred. Please try again.', isUser: false }]);
      } finally {
        setLoading(false); // Hide loader
      }
    }
  };

  const seekTo = (timeString) => {
    if (playerRef.current) {
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
      const timeMs = totalSeconds * 1000;
      console.log("Seeking to", timeMs, "ms");
      playerRef.current.seekTo(timeMs);
    }
  };

  
  const renderMessage = (msg) => {
    if (msg.isUser) {
      return <p>{msg.text}</p>;
    } else {
      const parts = msg.text.split('\n');
      let hasTimestamps = false;
      const renderedParts = [];

      parts.forEach((line, i) => {
        if (line.match(/^\d{1,2}:\d{2}:\d{2}/)) {
          if (!hasTimestamps) {
            hasTimestamps = true;
            // renderedParts.push(
            //   <p key="timestamp-header"><strong>Here are the relevant points with timestamps:</strong><br />
            //     Click on a timestamp to jump to that point in the video</p>
            // );
          }
          const [timestamp, ...rest] = line.split(' - ');
          const description = rest.join(' - ');
          renderedParts.push(
            <p key={i}>
              <a href="#" onClick={(e) => { e.preventDefault(); seekTo(timestamp); }}>
                {timestamp}
              </a>
              {' - ' + description}
            </p>
          );
        } else if (line.startsWith('-')) {
          renderedParts.push(<li key={i}>{line.substring(1).trim()}</li>);
        } else if (!line.startsWith('TIMESTAMPS:')) {
          renderedParts.push(<p key={i}>{line}</p>);
        }
      });
      return renderedParts;
    }
  };

  return (
    <div className="chatbot-container">
      <div className="chatbot-header">
        <img className="icon" alt="icon" src={Icon} /> 
        KPOINT.AI
      </div>
      <div className="chatbot-body" ref={chatbotBodyRef}>
      {conversation.map((msg, index) => (
          <div key={index} className={`message ${msg.isUser ? 'user-message' : 'bot-message'}`}>
            {renderMessage(msg, index)}
          </div>
        ))}

        {/* Display the loader when loading */}
        {loading && (
          <div className="loader-container">
            <PulseLoader color="#30c484" size={7} />
          </div>
        )}
      </div>
      <div className="chatbot-footer">
        <input
          type="text"
          placeholder={placeholder}
          value={message}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          id="chatInput"
          name="chatInput"
        />
       <button onClick={handleSendMessage}>Send</button> 
        {/* <button id='startrecording' onClick={handleRecording}>
          <FaMicrophone />
        </button> */}
        <select
          className="language-select"
          id="languageSelect"
          value={selectedLanguage}
          onChange={handleLanguageChange}
        >
          <option value="English">English</option>
          <option value="Bengali">Bengali</option>
          <option value="Gujarati">Gujarati</option>
          <option value="Hindi">Hindi</option>
          <option value="Kannada">Kannada</option>
          <option value="Malayalam">Malayalam</option>
          <option value="Marathi">Marathi</option>
          <option value="Punjabi">Punjabi</option>
          <option value="Tamil">Tamil</option>
          <option value="Telugu">Telugu</option>
        </select>
      </div>
    </div>
  );
};

export default Chatbot;